import { authPost } from "./api";

/** Ends the session (a failed call still leaves) and reloads to the sign-in form. */
export async function signOut(): Promise<void> {
  await authPost("sign-out", {}).catch(() => undefined);
  window.location.assign("/");
}
